import {
  DEFAULT_EMPTY_VALUE,
  DEFAULT_UNDEFINED_EMPTY_VALUE,
  PROVIDER_SOURCES,
} from 'src/constants/companyReport';
import { getNominalShareCapital, formatNumber } from 'src/services/companyReportDetail.service';
import capitalizeLetter from 'src/utils/capitalizeLetter.utils';

interface Props {
  activeIndex: string;
  handleOnClick: (index: string) => void;
  detailData: any;
}
const Shareholder = ({ activeIndex, handleOnClick, detailData }: Props) => {
  const directorAndShareDetails =
    detailData?.companyProfile?.companyProfile?.directorAndShareDetails;
  const shareHolders =
    detailData?.companyProfile?.companyProfile?.directorAndShareDetails?.shareHolders ?? [];

  const directorIssuedShareCapital = directorAndShareDetails?.issuedShareCapital?.value
    ? `${formatNumber(directorAndShareDetails?.issuedShareCapital.value)} (${
        directorAndShareDetails?.issuedShareCapital.currency
      })`
    : DEFAULT_EMPTY_VALUE;

  return (
    <div className={`card accordion ${activeIndex === 'shareholders' ? 'active' : ''}`}>
      <div className="accordion-heading" onClick={() => handleOnClick('shareholders')}>
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex gap-4 align-items-center">
            <h4 className="mb-0">
              SHAREHOLDERS <span> ({shareHolders.length})</span>
            </h4>
          </div>
          <div>
            <img
              className="chevron-icon"
              src={require('src/assets/images/icons/chevron-down.svg').default}
              alt="chevron-down icon"
            />
          </div>
        </div>
      </div>
      <div className="accordion-content">
        <div className="mt-3">
          <table className="accordion-table w-50">
            <tbody>
              <tr>
                <th>Nominal Share Capital</th>
                <td>
                  {detailData.source === PROVIDER_SOURCES.DNB
                    ? getNominalShareCapital(directorAndShareDetails?.nominalShareCapital)
                    : DEFAULT_UNDEFINED_EMPTY_VALUE}
                </td>
              </tr>
              <tr>
                <th>Issued Share Capital</th>
                <td>{directorIssuedShareCapital}</td>
              </tr>
            </tbody>
          </table>
          {detailData.source === PROVIDER_SOURCES.DNB ? (
            <DnbShareholder shareHolders={shareHolders} />
          ) : (
            <DefaultShareholder shareHolders={shareHolders} />
          )}
        </div>
      </div>
    </div>
  );
};

const DnbShareholder = ({ shareHolders }: any) => {
  return (
    <div className="mt-3">
      <table className="mt-12 accordion-table sm-th-md-td">
        <thead>
          <tr>
            <th>Name</th>
            <th>Shareholder Type</th>
            <th>Share Percentage</th>
            <th>Address</th>
          </tr>
        </thead>
        <tbody>
          {shareHolders.map((shareholder: any) => (
            <tr key={shareholder.name + shareholder.directOwnershipPercentage}>
              <td>{shareholder.name ?? DEFAULT_EMPTY_VALUE}</td>
              <td>
                {capitalizeLetter.capitalizeFirstLetter(shareholder.shareholderType) ??
                  DEFAULT_EMPTY_VALUE}
              </td>
              <td>{shareholder.directOwnershipPercentage ? shareholder.directOwnershipPercentage + '%' : DEFAULT_EMPTY_VALUE}</td>
              <td>{shareholder?.address !== '' ? shareholder.address : DEFAULT_EMPTY_VALUE}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const DefaultShareholder = ({ shareHolders }: any) => {
  return (
    <table className="mt-12 accordion-table sm-th-md-td">
      <thead>
        <tr>
          <th>Name</th>
          <th>Share Percentage</th>
          <th>Share Type</th>
          <th>Country</th>
        </tr>
      </thead>
      <tbody>
        {shareHolders.map((shareholder: any) => (
          <tr key={shareholder.name + shareholder.percentage}>
            <td>{shareholder.name ?? DEFAULT_EMPTY_VALUE}</td>
            <td>{shareholder.percentage ? shareholder.percentage + '%' : DEFAULT_EMPTY_VALUE}</td>
            <td>
              {capitalizeLetter.capitalizeFirstLetter(shareholder.shareType) ?? DEFAULT_EMPTY_VALUE}
            </td>
            <td>{shareholder.countryCode ?? DEFAULT_EMPTY_VALUE}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Shareholder;
